import React, { useEffect, useState } from "react";

import Map ,{Marker} from 'react-map-gl';
import { Navbar, Button, NavbarToggler, Collapse, Nav, NavItem, NavLink,NavbarText } from 'reactstrap';


const Mapbox = () => {
    const MAP_TOKEN = 'pk... your mapbox token'; 
      const [ viewport, setViewport ] = useState({    latitude: 37.532600,    longitude: 127.024612,    width: '100vw',    height: '100vh',    zoom: 12  }); 



    
     const add = () => {
        var { tempMarker } = this.state
        this.setState(prevState => ({
           markers: [...prevState.markers, tempMarker],
           tempMarker: null
         }))
    }

        return (    
          <div>
          <Map
          mapboxAccessToken="pk.eyJ1IjoicGVycGV0IiwiYSI6ImNrdW92cmRrazJ4aXcybnJ1bWttZ2NqcWgifQ.EBnLfgnXo10lCSz9mhdmtQ"
          initialViewState={{
            longitude: -122.4,
            latitude: 37.8,
            zoom: 14
          }}
          style={{width: 600, height: 400}}
          mapStyle="mapbox://styles/mapbox/streets-v9"
        >
           <Marker longitude={127.024612} latitude={37.532600} 
           
           
           >
            <div className="marker temporary-marker"><span></span></div>
      
      
          </Marker>



        </Map>


            <div>
            <Button  onClick={add}>Add</Button>

            </div>
          </div>
      
        
       );
      }; 
        export default Mapbox;
